import { Typography } from "@mui/material";
import React from "react";
import DetailCaption from "./DetailCaption";
import SectionHeader from "./SectionHeader";

function VolunteerWork() {
  return (
    <>
      <SectionHeader>Volunteer Work</SectionHeader>
      <DetailCaption>
        In order to conduct the singing school, ongoing work every day is
        required of all who are able.
      </DetailCaption>
      <Typography variant="body2">
        <ul>
          <li>Duties assigned and/or volunteered for must be completed.</li>
          <li>
            These include, but are not limited to, food preparation, cooking,
            dishwashing, table and chair set-up, sweeping, grounds cleanup,
            bathroom maintenance, class area set-ups, assemblies and class areas
            cleanliness and neatness, etc.
          </li>
        </ul>
      </Typography>
      <Typography variant="body2">
        <b>
          We encourage each one to do his/her part "as unto the Lord", Col.
          3:23.
        </b>
      </Typography>
    </>
  );
}

export default VolunteerWork;
